import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { getCustomers, getSelectedCustomer } from '../../../../../../../../selectors/tools';
import DTCustomerSearchResult from '../DTCustomerSearchResult/DTCustomerSearchResult';
import { setSelectedCustomer } from 'actions/tools/GladlyActions';

const DTCustomerSearchResultsList = () => {
  const customers = useSelector(getCustomers);
  const selectedCustomer = useSelector(getSelectedCustomer);
  const dispatch = useDispatch();

  const handleCheckOrder = (customer) => {
    dispatch(setSelectedCustomer(customer));
  };

  if (isEmpty(customers)) {
    return null;
  }

  return (
    <>
      {customers.map((customer, index) => (
        <DTCustomerSearchResult
          key={`search-result-list-SEARCH_CUSTOMERS_DECISION_TREE-result-${index}`}
          customer={customer}
          isSelected={customer.customerId === selectedCustomer?.customerId}
          onCheckboxClick={() => handleCheckOrder(customer)}
        />
      ))}
    </>
  );
};

export default DTCustomerSearchResultsList;
